import $axios from "../api/accessor";
import { $api } from "../api/api";

export const CountriesService = {
  async getAllCountries() {
    let response = await $axios
      .get($api("countries"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return response;
  },
  async getCountryDetails() {
    let response = await $axios
      .get($api("country_details"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
};
